import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { AuthService } from '../../../core/services/auth.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-user-list',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './user-list.component.html',
    styleUrl: './user-list.component.scss',
    styles: [`
        .status-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 0.75rem;
            margin-left: 8px;
            &.status-1 { background: rgba(46, 204, 113, 0.1); color: #2ecc71; } /* Active */
            &.status-2 { background: rgba(241, 196, 15, 0.1); color: #f1c40f; } /* Passive */
            &.status-3 { background: rgba(231, 76, 60, 0.1); color: #e74c3c; } /* Deleted */
        }
    `]
})
export class UserListComponent implements OnInit {
    private userService = inject(UserService);
    private authService = inject(AuthService);
    private router = inject(Router);
    private cdr = inject(ChangeDetectorRef);

    users: any[] = [];
    isLoading = true;
    isAdmin = true; // TODO: Implement real role check from token


    ngOnInit() {
        this.loadUsers();
    }



    loadUsers() {
        this.isLoading = true;
        this.userService.getAll().subscribe({
            next: (data: any) => {
                console.log('API Response:', data);
                try {
                    // Handle direct array or wrapped array
                    let items = Array.isArray(data) ? data : (data?.data || data?.items || []);

                    this.users = items.map((u: any) => ({
                        ...u,
                        username: u.username || `${u.firstName} ${u.lastName}`,
                        // Ensure role display logic handles array or single string
                        role: Array.isArray(u.roles) ? u.roles[0] : (u.roles || ''),
                        roles: Array.isArray(u.roles) ? u.roles : (u.roles ? [u.roles] : [])
                    }));
                    console.log('Mapped Users:', this.users);
                } catch (e) {
                    console.error('Error mapping users:', e);
                }

                this.isLoading = false;
                this.cdr.detectChanges(); // Force update
            },
            error: (err) => {
                console.error('API Error:', err);
                this.isLoading = false;
                this.cdr.detectChanges(); // Force update
            }
        });
    }

    deleteUser(id: string) {
        if (confirm('Are you sure you want to delete this user?')) {
            this.isLoading = true;
            this.userService.delete(id).subscribe({
                next: () => {
                    // Remove the user from the list
                    this.users = this.users.filter(u => u.id !== id);

                    this.isLoading = false;
                    this.cdr.detectChanges(); // Force UI update
                    console.log('User removed from list');
                },
                error: (err) => {
                    console.error('Failed to delete user:', err);
                    this.isLoading = false;
                    this.cdr.detectChanges();
                    alert('Failed to delete user. Please try again.');
                }
            });
        }
    }

    logout() {
        this.authService.logout();
    }

    createNew() {
        this.router.navigate(['/users/new']);
    }

    editUser(id: string) {
        this.router.navigate(['/users', id]);
    }



    getStatusLabel(status: number): string {
        switch (status) {
            case 1: return 'Active';
            case 2: return 'Passive';
            case 3: return 'Deleted';
            default: return 'Unknown';
        }
    }
}
